import { render, staticRenderFns } from "./JgBespokeSlot.vue?vue&type=template&id=970b6a14&scoped=true&"
import script from "./JgBespokeSlot.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeSlot.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeSlot.vue?vue&type=style&index=0&id=970b6a14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970b6a14",
  null
  
)

export default component.exports